import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { EventEmitter } from '@angular/core';
import { Component, Output } from '@angular/core';
import { IxellAPIService, StatsDropdownValue, StatsGraphFilterKind, StatsKeyfactorKind } from 'src/app/tools/api.service';


@Component({
  selector: 'stats-ag-modal',
  templateUrl: './ag-modal.component.html',
  styleUrls: ['./ag-modal.component.scss']
})

export class StatsAGModalComponent {
  @Output() close = new EventEmitter<void>();
  @Output() save = new EventEmitter<number>();

  graphsList: string[] = [];
  selIdx: number = -1;

  private statsGetUsableGraphsSub: any;

  constructor(private apiService: IxellAPIService) { }

  ngOnInit() {
    this.statsGetUsableGraphsSub = this.apiService.statsGetUsableGraphs().subscribe(data => {
      this.graphsList = data;

      if (this.statsGetUsableGraphsSub != null) this.statsGetUsableGraphsSub.unsubscribe();
    });
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    if (this.statsGetUsableGraphsSub != null) this.statsGetUsableGraphsSub.unsubscribe();
  }

  doClose() {
    this.close.emit();
  }

  doSave() {
    if (this.selIdx >= 0 && this.selIdx < this.graphsList.length)
      this.save.emit(this.selIdx);
  }

  changeSelection(value: number) {
    this.selIdx = value;
  }
}
